import { fun_PostAction } from "@/api/index";
import {fun_GetKeys} from "@/utils/validate";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 查询表单字段
      form: {
        prjName: null, // 项目名称
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "prjName",
          placeholder: "请输入",
        },
      ],
      // 表头按钮组
      btnList: [
        {
          name: "添加变更申请",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          minWidth: "380",
          isShow: true,
          fixed: true,
        },
        {
          label: "标段数",
          prop: "section",
          fixed: true,
          minWidth: "80"
        },
        {
          label: "状态",
          slotName: "state",
          fixed: true,
          minWidth: "130",
        },
        {
          label: "前项目负责人（总监）",
          prop: "regBasicinfoName",
          fixed: true,
          minWidth: "200"
        },
        {
          label: "是否联合体投标",
          prop: "isUnionTender",
          minWidth: "150"
        },
        {
          label: "招标类别",
          prop: "tenderClassNumName",
          minWidth: "150"
        },
        {
          label: "招标内容",
          prop: "tenderContent",
          minWidth: "150"
        },
        {
          label: "招标方式",
          prop: "tenderTypeNumName",
          minWidth: "150"
        },
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 勾选的数组
      multipleSelection: [],
    };
  },
  // 注册组件
  components: {
  },

  // 模板编译完成
  mounted() {
    // 获取一览
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/projectManagerRecordChange/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "添加变更申请":
          // 跳转详情页面
          this.$router.push({
            path: "/projectManagerRecordChangeDetail",
            query: { controllerFlg: "insert" }
          });
          break;
        case "修改":
          // 调用修改方法
          this.fun_Edit();
          break;
        default:
          // 调用删除方法
          this.fun_Del();
      }
    },
    /**
     * 修改
     * @author shuhua
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 状态
          let state = this.multipleSelection[0].state;
          // 如果审核中或者审核通过
          if (state == "tj" || state == "tg") {
            this.$alert("存在已提交或已解锁的项目，不能申请解锁！", "warning");
            return;
          }
          // 跳转详情页面
          this.$router.push({
            path: "/projectManagerRecordChangeDetail",
            query: {
              controllerFlg: "update",
              id: this.multipleSelection[0].id,
            }
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请至少选中一行数据！", "warning");
        return;
      }
    },
    /**
     * 删除的方法
     * @author shuhua
     */
    fun_Del() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过一条
        if (this.multipleSelection.length > 1) {
          // 勾选多条时，提示
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          // 状态
          let state = this.multipleSelection[0].state;
          // 如果提交，审核中或者审核通过
          if (state == "tj" || state == "tg") {
            this.$alert("当前所选项目中，存在已提交或审核通过的项目，不能删除！", "warning");
            return;
          }
          // 弹出询问confirm
          this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 获取id
            const id = fun_GetKeys(this.multipleSelection);
            // 发起请求，获取结果集
            fun_PostAction("/projectManagerRecordChange/delete?keys=" + id).then(res => {
              // 解构res.data
              const { result, msg } = res.data;
              // 判断请求是否成功
              if (result) {
                // 查询列表
                this.fun_GetList();
                // 提示删除成功
                this.$message.success(msg);
              } else {
                // 请求失败，提示信息
                this.$message.error(msg);
              }
            });
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查看详情
     * @author shuhua
     */
    fun_LookDetails(e) {
      // 请求参数
      let obj = {
        controllerFlg: "detail",
        id: e.val.id
      }
      // 跳转详情页面
      this.$router.push({
        path: "/projectManagerRecordChangeDetail",
        query: obj,
      });
    },
  }
};
